/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { Box, Typography } from "@mui/material";
import VmVButton from "../components/VmVButtons";
import VmVDataArray from "../components/VmVDataArray";
import DropDownData from "../dropdownsData/metier.json";
import { CSVLink } from "react-csv";
import { ReactComponent as LeftArrow } from "../assets/icons/left-arrow.svg";
import { colors, typography } from "../constants/theme";
import { ReactComponent as CSV } from "../assets/icons/csv.svg";
import { BarChart, XAxis, YAxis, Bar, Cell, LabelList } from "recharts";
import VmVSelect from "../components/VmVSelect";
import { useNavigate } from "react-router-dom";
import VmVTextInput from "../components/VmVTextInput";
import { useQuery } from "@tanstack/react-query";
import { convertDataToCSV, downloadCSV } from "../helpers/DataToCsv";
import { fetchData } from "../helpers/fetch";
import formatDropDownData from "../helpers/formatDropDown";
import { useEffect, useReducer } from "react";
// import useWindowSize from "../hooks/useGetWindowSize";
import { useTranslation } from "react-i18next";

interface IReducerState {
  text: string;
  metier: string;
}

interface IReducerAction {
  type: string;
  payload: string;
}

const initialState: IReducerState = {
  text: "",
  metier: "",
};

const reducer = (
  state: IReducerState,
  action: IReducerAction,
): IReducerState => {
  switch (action.type) {
    case "SET_TEXT":
      return {
        ...state,
        text: action.payload,
      };
    case "SET_METIER":
      return {
        ...state,
        metier: action.payload,
      };
    case "RESET": {
      return {
        text: "",
        metier: "",
      };
    }

    default:
      return state;
  }
};

const InscriptionsAndParticipationsDetails = (): JSX.Element => {
  const navigation = useNavigate();
  const [filters, dispatch] = useReducer(reducer, initialState);
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ["etablissements/inscription-participations"],
    queryFn: async () =>
      await fetchData(
        "etablissements/inscription-participations?page=1&pageLimit=10000",
      ),
  });

  const formateData = (dataToFormat: any): any[] => {
    const reformateData: any[] = [];
    if (dataToFormat !== undefined) {
      dataToFormat?.etablissements?.forEach((element) => {
        if (
          element?.nombre_disponibilites_restauration !== undefined ||
          element?.nombre_participations_restauration !== undefined
        ) {
          reformateData.push({
            [t("table.headers.establishmentName")]: element?.name,
            [t("table.headers.registrationsCount")]:
              element?.nombre_disponibilites_restauration ?? 0,
            [t("table.headers.participationsCount")]:
              element?.nombre_participations_restauration ?? 0,
          });
        }
      });
    }
    return reformateData;
  };

  const filterData = (dataToFilter: any[], filters: IReducerState): any[] => {
    if (dataToFilter === undefined || dataToFilter.length === 0) return [];
    return (
      dataToFilter
        .filter((value) => {
          return value[t("table.headers.establishmentName")]
            ?.toLowerCase()
            ?.includes(filters.text.toLowerCase());
        })
        // comment existe seulement JobDay, il n'est pas nécessaire de filtrer par métier, mais il est conservé pour la compatibilité
        .filter((value) => {
          return (
            value[t("table.headers.job")]?.toLowerCase() ===
              filters.metier.toLowerCase() || filters.metier === ""
          );
        })
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onClickDownloadCSV = (): void => {
    const csvData = convertDataToCSV(formateData(data));
    downloadCSV(csvData);
  };

  const tableCells = [
    t("table.headers.establishmentName"),
    t("table.headers.registrationsCount"),
    t("table.headers.participationsCount"),
  ];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <VmVButton
        onClick={() => {
          navigation(-1);
        }}
        type="back"
        LeftIcon={<LeftArrow stroke={colors.darkGrey[200]} />}
      >
        {t("common.back")}
      </VmVButton>
      <Box
        alignSelf="center"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography
          color={colors.darkBlue}
          sx={{ ...typography.title1 }}
          textAlign="center"
        >
          {t("pages.fillRate.title")} <br />
          <span style={{ fontWeight: 400, fontSize: 18 }}>
            {t("pages.fillRate.subtitle")}
          </span>
        </Typography>
        <InscriptionsAndParticipationsDetailsChart />
        <Box display="flex" flexDirection="column" gap={8}>
          <Box display="flex" justifyContent="center">
            <VmVTextInput
              placeholder={t("components.inputs.searchEstablishment")}
              value={filters.text}
              onChange={(event) => {
                dispatch({ type: "SET_TEXT", payload: event.target.value });
              }}
            />
          </Box>
          <Box>
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" gap={1}>
                {/* <VmVButton
                  onClick={() => {
                    dispatch({ type: "RESET", payload: "" });
                  }}
                  type="primary"
                >
                  {t("common.reset")}
                </VmVButton>
                <VmVSelect
                  label={t("components.filters.allJobs")}
                  options={formatDropDownData(DropDownData)}
                  value={filters.metier}
                  onChange={(value) => {
                    dispatch({ type: "SET_METIER", payload: value });
                  }}
                /> */}
              </Box>
              <Box>
                <VmVButton
                  onClick={() => {}}
                  type="secondary"
                  RightIcon={<CSV />}
                >
                  <CSVLink
                    data={formateData(data)}
                    filename={"data.csv"}
                    style={{
                      color: "inherit",
                      textDecoration: "inherit",
                      fontFamily: "inherit",
                    }}
                    target="_blank"
                  >
                    {t("common.export")}
                  </CSVLink>
                </VmVButton>
              </Box>
            </Box>
          </Box>
          <VmVDataArray
            cells={tableCells}
            rows={filterData(formateData(data), filters)}
            showFooter
          />
        </Box>
      </Box>
    </Box>
  );
};

export const InscriptionsAndParticipationsDetailsChart = ({
  width,
  height,
  home,
}: {
  width?: number;
  height?: number;
  home?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["etablissements/inscription-participations"],
    queryFn: async () =>
      await fetchData(
        "etablissements/inscription-participations?page=1&pageLimit=10000",
      ),
  });

  const getchartData = (dataToFormat: any): any[] => {
    if (dataToFormat === undefined || dataToFormat.length === 0) return [];
    const restauration = [0, 0];

    dataToFormat?.etablissements.forEach((element: any) => {
      restauration[0] += parseInt(
        element?.nombre_disponibilites_restauration ?? 0,
      );
      restauration[1] += parseInt(
        element?.nombre_participations_restauration ?? 0,
      );
    });

    const totalRestauration = restauration[0] + restauration[1];
    const total = totalRestauration; // + totalAnimation + totalMaintenance + totalHotellerie + totalAccueil;

    return [
      {
        name: t("table.headers.catering"),
        x: restauration[1],
        y: restauration[0],
        percentage: total > 0 ? (totalRestauration / total) * 100 : 0,
      },
    ];
  };

  return (
    <Box
      alignSelf="center"
      display="flex"
      flexDirection="column"
      gap={2.5}
      mb={home === true ? 3 : 8}
    >
      <Box mt={8} alignSelf="center">
        <BarChart
          width={width ?? 900}
          height={height ?? 500}
          data={getchartData(data)}
        >
          <XAxis
            style={{ color: "red" }}
            tick={{ fill: colors.darkBlue }}
            dataKey="name"
          />
          <YAxis tick={false} />
          <Bar dataKey="x" stackId="a" fill={colors.green}>
            <LabelList
              dataKey="percentage"
              position="top"
              formatter={(value) => `${value.toFixed(2)}%`}
            />
            {getchartData(data).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors.green} />
            ))}
          </Bar>
          <Bar dataKey="y" stackId="a" fill={colors.orange50}>
            <LabelList
              dataKey="percentage"
              position="top"
              formatter={(value) => `${value.toFixed(2)}%`}
              fill={colors.green}
            />
            {getchartData(data).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors.orange50} />
            ))}
          </Bar>
        </BarChart>
      </Box>
    </Box>
  );
};

export default InscriptionsAndParticipationsDetails;
